import { useCallback } from 'react';
import {
  ToggleGroup,
  ToggleGroupItem,
  ToggleGroupProps,
} from '@/components/toggle';
import { FeedbackControlProps } from './types';
import { cn, memoClassNames } from '@/utils';
import { ThumbsDown, ThumbsUp } from 'lucide-react';

const classes = memoClassNames('FeedbackThumbs', ['root']);

export type FeedbackThumbsProps = FeedbackControlProps & {
  size?: ToggleGroupProps['size'];
};

export function FeedbackThumbs({
  onValueChange = () => {},
  value: initialValue,
  className,
  ...others
}: FeedbackThumbsProps) {
  const handleValueChange = useCallback(
    (controlValue: string) => {
      onValueChange({ rating: controlValue === 'positive' ? 1 : -1 });
    },
    [onValueChange]
  );

  const rootProps: ToggleGroupProps = {
    className: cn(classes.root, className),
    onValueChange: handleValueChange,
    type: 'single',
  };

  if (initialValue) {
    rootProps.defaultValue = initialValue.rating > 0 ? 'positive' : 'negative';
  }

  console.log({
    ...others,
    ...rootProps,
  });

  return (
    <ToggleGroup size="sm" aria-label="Feedback" {...others} {...rootProps}>
      <ToggleGroupItem
        value="positive"
        aria-label="Positive"
        className="mm:text-muted-foreground mm:hover:bg-transparent mm:hover:text-accent mm:data-[state=on]:bg-transparent mm:data-[state=on]:text-primary"
      >
        <ThumbsUp />
      </ToggleGroupItem>
      <ToggleGroupItem
        value="negative"
        aria-label="Negative"
        className="mm:text-muted-foreground mm:hover:bg-transparent mm:hover:text-accent mm:data-[state=on]:bg-transparent mm:data-[state=on]:text-primary"
      >
        <ThumbsDown />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}

FeedbackThumbs.displayName = 'FeedbackThumbs';
